import { StaticImageData } from 'next/image'

import {
  ForbesImage,
  FoxImage,
  GolfDigestImage,
  GoodGolfImage,
  KayoImage,
  TheAustralianImage,
  WomensGolfImage,
} from 'Assets/Images/Sections/ExecutiveInviteWelcomeSection'

type WelcomeSectionGalleryItem = {
  id: string
  image: StaticImageData
  alt: string
}

export const WELCOME_SECTION_GALLERY_ITEMS: WelcomeSectionGalleryItem[] = [
  {
    id: 'Forbes',
    image: ForbesImage,
    alt: '',
  },
  {
    id: 'TheAustralian',
    image: TheAustralianImage,
    alt: '',
  },
  {
    id: 'Fox',
    image: FoxImage,
    alt: '',
  },
  {
    id: 'Kayo',
    image: KayoImage,
    alt: '',
  },
  {
    id: 'GolfDigest',
    image: GolfDigestImage,
    alt: '',
  },
  {
    id: 'GoodGolf',
    image: GoodGolfImage,
    alt: '',
  },
  {
    id: 'WomensGolf',
    image: WomensGolfImage,
    alt: '',
  },
]
